// Klaviyo Form Submission Event
window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
        //gtag('event', 'conversion', {'send_to': 'AW-955665271/JwmFCMCPv9IYEPeW2ccD'});
        window.analytics.identify({email: e.detail.metaData.$email});
        window.analytics.track('Email Sign Up', {
            formId: e.detail.formId,
            formSource: e.detail.metaData.$source, 
            email: e.detail.metaData.$email,
        })
    }
});
// Product Added to Cart Event
document.addEventListener('ajaxProduct:added', function(e) {
    var variant = e.detail.product;
    //console.log(variant);
    var item = {
        id: variant.id,
        name: variant.product_title,
        type: variant.product_type,
        url: variant.url,
        productType: variant.product_type,
        imageUrl: variant.image,
        variantSelected: variant.variant_id,
        price: variant.price,
        priceMin: variant.discount_price,
        priceMax: variant.original_price,
        sale: variant.discount_price,
        value: Math.round(variant.price)/100,
        currency: 'EUR'
    }
    _learnq.push(['track', 'Product Added', item]);
    window.analytics.track('Product Added', item);
});
document.addEventListener('cart:updated', function(e) {
    console.log(e.detail.cart);
    let cart = e.detail.cart;
    window.analytics.track('Cart Updated', {
        itemCount: cart.item_count,
	      cartSubtotal: cart.items_subtotal_price,
	      cartCurrency: cart.currency,
	      totalPrice: cart.total_price,
	      cartItems: cart.items
    })
});